<template>
  <div class="bracket">
    <h5 class="text-white pt-0" v-if="winnersarray.length < 3">{{ $t('Click on the Left or the Right to select.') }}</h5>

    <h5 class="text-white pt-0" v-if="winnersarray.length === 3">{{ $t('Confirm your winner.') }}</h5>

    <div class="flex flex-wrap items-center flex-col-reverse md:flex-col"
      v-if="bracket.length > 1"
    >
      <div class="bracket-wrapper py-3">
        <div class="bracket-responsive">

          <!-- First Item -->
          <button class="bracket-item bracket-item__first mb-1 mr-1 relative cursor-pointer"
            :class="{active: leftChosen}"
            tabindex="0"
            type="button"
            :aria-label="bracket[0].attributes.title.text"
            aria-describedby="description_left"
            :aria-pressed="leftChosen ? true : false"
            @click="(leftChosen = !leftChosen), (rightChosen = false)"
          >
            <div class="bracket-item-center">
              <div class="attributes">
                  <div class="attributes-rows">
                    <span class="title stylebr" v-html="bracket[0].attributes.title.text">{{ bracket[0].attributes.title.text }}</span>
                    <div class="description stylebr">
                        <img v-if="bracket[0].attributes.image" :src="bracket[0].attributes.image.text" :alt="bracket[0].attributes.title.text" class="image"/>
                        <span id="description_left" v-html="bracket[0].attributes.description.text">{{ bracket[0].attributes.description.text }}</span>
                          <button
                            v-if="bracket[0].attributes['showmore']"
                            id="modal_first"
                            class="showmore"
                            type="button"
                            @click.stop="showModal('first')"
                          >
                            <i aria-hidden="true" class="material-icons">read_more</i><i aria-hidden="true" class="material-icons">menu_book</i>
                          </button>
                          <card-modal ref="modal_first" v-if="bracket[0].attributes['showmore']">
                            <span v-html="bracket[0].attributes['showmore'].text"></span>
                          </card-modal>
                      </div>
                  </div>
              </div>
            </div>
          </button>

          <!-- Second Item -->
          <button class="bracket-item mb-1 mr-0 relative cursor-pointer"
            :class="{active: rightChosen}"
            tabindex="0"
            type="button"
            :aria-label="bracket[1].attributes.title.text"
            aria-describedby="description_right"
            :aria-pressed="rightChosen ? true : false"
            @click="(rightChosen = !rightChosen), (leftChosen = false)"
          >
            <div class="bracket-item-center">
              <div class="attributes">
                  <div class="attributes-rows">
                    <span class="title stylebr" v-html="bracket[1].attributes.title.text">{{ bracket[1].attributes.title.text }}</span>
                    <div class="description stylebr">
                        <img v-if="bracket[1].attributes.image" :src="bracket[1].attributes.image.text" :alt="bracket[1].attributes.title.text" class="image"/>
                        <span id="description_right" v-html="bracket[1].attributes.description.text">{{ bracket[1].attributes.description.text }}</span>
                          <button
                            v-if="bracket[1].attributes['showmore']"
                            id="modal_second"
                            class="showmore"
                            type="button"
                            @click.stop="showModal('second')"
                          >
                            <i aria-hidden="true" class="material-icons">read_more</i><i aria-hidden="true" class="material-icons">menu_book</i>
                          </button>
                          <card-modal ref="modal_second" v-if="bracket[1].attributes['showmore']">
                            <span v-html="bracket[1].attributes['showmore'].text"></span>
                          </card-modal>
                      </div>
                  </div>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>

    <!-- Once it's down to the final two -->
    <div class="flex flex-wrap items-center flex-col-reverse md:flex-col" v-if="winnersarray.length >= 2">
      <div class="bracket-wrapper py-3">
        <div class="bracket-responsive">
          <!-- First Item -->
          <button class="bracket-item bracket-item__first mb-1 mr-1 relative cursor-pointer"
            :class="{active: leftChosen}"
            tabindex="0"
            type="button"
            :aria-label="winnersarray[0].attributes.title.text"
            aria-describedby="winner_description_left"
            :aria-pressed="leftChosen ? true : false"
            @click="(leftChosen = !leftChosen), (rightChosen = false)"
          >
            <div class="bracket-item-center">
              <div class="attributes">
                  <div class="attributes-rows">
                    <span class="title stylebr" v-html="winnersarray[0].attributes.title.text">{{ winnersarray[0].attributes.title.text }}</span>
                    <div class="description stylebr">
                        <img v-if="winnersarray[0].attributes.image" :src="winnersarray[0].attributes.image.text" :alt="winnersarray[0].attributes.title.text" class="image"/>
                        <span id="winner_description_left" v-html="winnersarray[0].attributes.description.text">{{ winnersarray[0].attributes.description.text }}</span>
                          <button
                            v-if="winnersarray[0].attributes['showmore']"
                            id="modal_winnerA"
                            class="showmore"
                            type="button"
                            @click.stop="showModal('winnerA')"
                          >
                            <i aria-hidden="true" class="material-icons">read_more</i><i aria-hidden="true" class="material-icons">menu_book</i>
                          </button>
                          <card-modal ref="modal_winnerA" v-if="winnersarray[0].attributes['showmore']">
                            <span v-html="winnersarray[0].attributes['showmore'].text"></span>
                          </card-modal>
                      </div>
                  </div>
              </div>
            </div>
          </button>

          <!-- Second Item -->
          <button class="bracket-item mb-1 mr-0 relative cursor-pointer"
            :class="{active: rightChosen}"
            tabindex="0"
            type="button"
            :aria-label="winnersarray[1].attributes.title.text"
            aria-describedby="winner_description_right"
            :aria-pressed="rightChosen ? true : false"
            @click="(rightChosen = !rightChosen), (leftChosen = false)"
          >
            <div class="bracket-item-center">
              <div class="attributes">
                  <div class="attributes-rows">
                    <span class="title stylebr" v-html="winnersarray[1].attributes.title.text">{{ winnersarray[1].attributes.title.text }}</span>
                    <div class="description stylebr">
                        <img v-if="winnersarray[1].attributes.image" :src="winnersarray[1].attributes.image.text" :alt="winnersarray[1].attributes.title.text" class="image"/>
                        <span id="winner_description_right" v-html="winnersarray[1].attributes.description.text">{{ winnersarray[1].attributes.description.text }}</span>
                          <button
                            v-if="winnersarray[1].attributes['showmore']"
                            id="modal_winnerB"
                            class="showmore"
                            type="button"
                            @click.stop="showModal('winnerB')"
                          >
                            <i aria-hidden="true" class="material-icons">read_more</i><i aria-hidden="true" class="material-icons">menu_book</i>
                          </button>
                          <card-modal ref="modal_winnerB" v-if="winnersarray[1].attributes['showmore']">
                            <span v-html="winnersarray[1].attributes['showmore'].text"></span>
                          </card-modal>
                      </div>
                  </div>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>

    <div class="submit-button-wrapper z-50 pt-0" v-if="bracket.length > 1">
        <transition name="fade" mode="in-out">
          <div v-if="leftChosen">
            <input type="hidden" name="selectThisLeft" :value="bracket[0].id">
            <button id="selectThisLeft" @click="selectThis(bracket[0], bracket[1], bracket[1].id, bracket[0].id),(leftChosen = false), (rightChosen = false)" type="submit" class="centerit px-5 py-2">Choose {{ bracket[0].attributes['title'].text }}<i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
          </div>
        </transition>

        <transition name="fade" mode="in-out">
          <div v-if="rightChosen">
            <input type="hidden" name="selectThisRight" :value="bracket[1].id">
            <button id="selectThisRight" @click="(selectThis(bracket[1], bracket[0], bracket[0].id, bracket[1].id)),(leftChosen = false), (rightChosen = false)" type="submit" class="centerit px-5 py-2">Choose {{ bracket[1].attributes['title'].text }}<i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
          </div>
        </transition>
    </div>

    <!-- For the final two -->
    <div class="submit-button-wrapper z-50 pt-0" v-if="winnersarray.length >= 2">
        <div v-if="leftChosen">
          <input type="hidden" name="selectThisLeft" :value="winnersarray[0].id">
          <button id="selectThisLeft" @click="selectThis(winnersarray[0], winnersarray[1], winnersarray[1].id, winnersarray[0].id),(leftChosen = false), (rightChosen = false)" type="submit" class="centerit px-5 py-2">
            <template v-if="winnersarray.length === 3, demo == 1"> {{ $t('Restart Demo') }} </template>
            <template v-else>
            {{ $t('Choose') }} {{ winnersarray[0].attributes['title'].text }}</template>
            <i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
        </div>

        <div v-if="rightChosen">
          <input type="hidden" name="selectThisRight" :value="winnersarray[1].id">
          <button id="selectThisRight" @click="(selectThis(winnersarray[1], winnersarray[0], winnersarray[0].id, winnersarray[1].id)),(leftChosen = false), (rightChosen = false)" type="submit" class="centerit px-5 py-2">
            <template v-if="winnersarray.length === 3, demo == 1"> {{ $t('Restart Demo') }} </template>
            <template v-else>
            {{ $t('Choose') }} {{ winnersarray[1].attributes['title'].text }}</template>
            <i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
        </div>
    </div>

    <div class="">
      <div class="tournament-brackets">
        <div class="block">
          <div class="quarter-bracket">
            <div class="round round-4">
                <div class="match">
                    <div class="match__content">
                      {{ data[0].attributes.title.text }}
                    </div>
                </div>
                <div class="match">
                    <div class="match__content">
                      {{ data[1].attributes.title.text }}
                    </div>
                </div>
                <div class="match">
                    <div class="match__content">
                      {{ data[2].attributes.title.text }}
                    </div>
                </div>
                <div class="match">
                    <div class="match__content">
                      {{ data[3].attributes.title.text }}
                    </div>
                </div>
            </div>
            <div class="round round-2">
                <div class="match">
                    <div class="match__content">
                      <span v-if="winnersarray.length > 0">
                      {{ winnersarray[0].attributes.title.text }}
                      </span>
                    </div>
                </div>
                <div class="match">
                    <div class="match__content">
                      <span v-if="winnersarray.length > 1">
                      {{ winnersarray[1].attributes.title.text }}
                      </span>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: {
      array: '',
      route: '',
      demo:'',
  },
  data () {
    return {
      leftChosen: false,
      rightChosen: false,
      hidebracket: true,
      bracket: this.array.slice(0),
      data: this.array,
      finalarray: [],
      submitarray: [],
      winnersarray: []
    }
  },
  methods: {
    showModal(ID) {
      let modal_id = "modal_" + ID;
      this.$refs[modal_id].show();
    },
    selectThis(winner, loser, loserid, winnerid){
        this.finalarray.push(loser);
        this.submitarray.push(loserid);
        this.winnersarray.push(winner);
        this.bracket.splice(winner, 1);
        this.bracket.splice(loser, 1);
        if (this.winnersarray.length === 3 && this.demo == 1)
          this.restartBracket();
        else if (this.winnersarray.length === 3)
          this.submitarray.push(winnerid),
          this.submitFinal();

        console.log('Winner Selected');
    },
    restartBracket() {
              $( "#submitFinal").addClass( "loading" );
              location.reload();
            },
    submitFinal() {
              $( "#submitFinal").addClass( "loading" );
              axios.put(this.route, {
                results: this.submitarray
              }).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            },
  }
};
</script>
